import * as React from "react";
import { Box, Typography } from "@mui/material";
import { InlineText } from "../InlineText";
import { ReactComponent as CurrancyIcon } from "../../assets/svgs/currencyCyan.svg";
import BadgeIcon from "@mui/icons-material/Badge";
import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const PlaidInstruction = () => {
    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="h1" component="h1">
                    Here's what to expect
                </Typography>
            </Box>
            <Box>
                <InlineText
                    sx={{ mt: "2rem" }}
                    text={
                        <Typography variant="h6" component="h6">
                            <b>Verify your identity with valid ID</b>
                        </Typography>
                    }
                    icon={
                        <BadgeIcon
                            style={{
                                width: "16px",
                            }}
                        ></BadgeIcon>
                    }
                ></InlineText>

                <InlineText
                    sx={{ mt: "10px" }}
                    text={
                        <Typography variant="h6" component="h6">
                            <b>Verify your income</b>
                        </Typography>
                    }
                    icon={<CurrancyIcon style={{ width: "16px" }}></CurrancyIcon>}
                ></InlineText>

                <InlineText
                    sx={{ mt: "10px", ml: "10px" }}
                    text={
                        <Typography variant="h6" component="h6">
                            With Plaid (recommended)
                        </Typography>
                    }
                    icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                ></InlineText>
                <InlineText
                    sx={{ mt: "10px", ml: "10px" }}
                    text={
                        <Typography variant="h6" component="h6">
                            AND/OR upload your income documents (ie tax returns, pay stubs, bank statements, etc...)
                        </Typography>
                    }
                    icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                ></InlineText>
                <InlineText
                    sx={{ mt: "2rem" }}
                    text={
                        <Typography variant="h6" component="h6">
                            <b>We'll use your personal infomation to...</b>
                        </Typography>
                    }
                    icon={<InfoOutlinedIcon style={{ width: "16px" }}></InfoOutlinedIcon>}
                ></InlineText>

                <InlineText
                    sx={{ mt: "10px", ml: "10px" }}
                    text={
                        <Typography variant="h6" component="h6">
                            Check your credit score
                        </Typography>
                    }
                    icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                ></InlineText>
                <InlineText
                    sx={{ mt: "10px", ml: "10px" }}
                    text={
                        <Typography variant="h6" component="h6">
                            Do a background check
                        </Typography>
                    }
                    icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                ></InlineText>
                <InlineText
                    sx={{ mt: "10px", ml: "10px" }}
                    text={
                        <Typography variant="h6" component="h6">
                            Check your residential and employment history
                        </Typography>
                    }
                    icon={<CheckIcon style={{ width: "16px" }}></CheckIcon>}
                ></InlineText>
            </Box>
        </>
    );
};

export { PlaidInstruction };
